import {THREE} from 'mini-tokyo-3d';

export const {
    AmbientLight,
    BoxGeometry,
    BufferAttribute,
    Camera,
    Color,
    DirectionalLight,
    DoubleSide,
    Group,
    InstancedBufferGeometry,
    InstancedMesh,
    InstancedBufferAttribute,
    Matrix4,
    Mesh,
    MeshLambertMaterial,
    RawShaderMaterial,
    Scene,
    Vector4,
    WebGLRenderer
} = THREE;
